import { Button, Flex, Spinner, Text } from '@chakra-ui/react';
import { Card, Table } from '@ui';
import { useState } from 'react';

type RowPayload = {
  submittal_id: number;
};

export default function ExportSubmittalLogModal({
  selectedSubmittals,
  onExport,
}: {
  selectedSubmittals: {
    id: number;
    title: string;
    number: string;
    revision: number;
  }[];
  onExport: (rows: RowPayload[]) => Promise<void>;
}) {
  const [isExporting, setIsExporting] = useState(false);

  return (
    <Flex direction="column" gap={5} width="full">
      <Text>
        The export will use each submittal’s saved metadata automatically.
      </Text>

      <Flex direction="column" gap={2}>
        <Text fontWeight="semibold">Selected submittals</Text>

        <Card>
          <Table
            columns={[
              {
                number: {
                  label: 'Number',
                  width: '120px',
                },
              },
              {
                revision: {
                  label: 'Revision',
                  width: '120px',
                },
              },
              {
                title: {
                  label: 'Title',
                  width: '240px',
                },
              },
              {
                id: {
                  label: 'ID',
                  width: '100px',
                },
              },
            ]}
            items={selectedSubmittals ?? []}
          />
        </Card>
      </Flex>

      <Button
        colorPalette="blue"
        alignSelf="flex-start"
        isDisabled={isExporting || !selectedSubmittals.length}
        onClick={async () => {
          const rows: RowPayload[] = selectedSubmittals.map((s) => ({
            submittal_id: s.id,
          }));

          setIsExporting(true);
          try {
            await onExport(rows);
          } finally {
            setIsExporting(false);
          }
        }}
      >
        {isExporting && <Spinner size="xs" mr={2} />}
        {isExporting ? 'Exporting…' : 'Export'}
      </Button>
    </Flex>
  );
}